import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { projects } from '../../data/mock';

const ProjectsSection = () => {
  const featuredProjects = projects.filter((p) => p.featured).slice(0, 4);

  return (
    <section className="bg-navy py-16">
      <div className="container-main">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-display mb-10">Our Projects</h2>

        <div className="grid md:grid-cols-2 gap-6">
          {featuredProjects.map((project, index) => (
            <Link
              key={project.id}
              to={`/projects/${project.id}`}
              className="group relative overflow-hidden rounded-xl aspect-[4/3]"
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/30 to-transparent" />
              
              {/* Project Info Overlay */}
              <div className="absolute top-4 left-4">
                <h3 className="text-xl font-bold text-white font-display">{project.title}</h3>
                <p className="text-white/60 text-sm">{project.category}</p>
              </div>
              
              {/* Tags */}
              <div className="absolute bottom-4 left-4 flex gap-2">
                {project.tags.slice(0, 2).map((tag) => (
                  <span
                    key={tag}
                    className="text-xs font-medium px-3 py-1 bg-lime text-navy rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Explore Button */}
              <div className="absolute bottom-4 right-4">
                <span className="inline-flex items-center gap-1 text-lime text-sm font-medium">
                  Get Explore
                  <ArrowUpRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
